import { render, staticRenderFns } from "./searchForm.vue?vue&type=template&id=0b976811&scoped=true"
import script from "./searchForm.vue?vue&type=script&lang=ts"
export * from "./searchForm.vue?vue&type=script&lang=ts"
import style0 from "./searchForm.vue?vue&type=style&index=0&id=0b976811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b976811",
  null
  
)

export default component.exports